module.exports = __webpack_public_path__ + "img/page6.511452c8.png";